import { render, staticRenderFns } from "./GideBlogList.vue?vue&type=template&id=d80a87c0&scoped=true"
import script from "./GideBlogList.vue?vue&type=script&lang=js"
export * from "./GideBlogList.vue?vue&type=script&lang=js"
import style0 from "./GideBlogList.vue?vue&type=style&index=0&id=d80a87c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80a87c0",
  null
  
)

export default component.exports